<template>
    <div>
        <b-loading :is-full-page="true" :active.sync="isLoading"></b-loading>
        <error-notifications :errors="errors"></error-notifications>
        <form id="login" @submit.prevent="logIn">
            <div class="field" :class="{'is-horizontal': horizontal}">
                <div v-if="horizontal" class="field-label is-normal">
                    <label class="label" for="username">Username</label>
                </div>
                <label v-else class="label" for="username">Username</label>
                <div class="field-body">
                    <div class="control has-icons-left">
                        <input id="username" class="input" type="text" name="username" v-model="username" required>
                        <span class="icon is-small is-left">
                            <i class="fas fa-user"></i>
                        </span>
                    </div>
                </div>
            </div>
            <div class="field" :class="{'is-horizontal': horizontal}">
                <div v-if="horizontal" class="field-label is-normal">
                    <label class="label" for="password">Password</label>
                </div>
                <label v-else class="label" for="password">Password</label>
                <div class="field-body">
                    <div class="control has-icons-left">
                        <input id="password" class="input" type="password" name="password" v-model="password" required>
                        <span class="icon is-small is-left">
                            <i class="fas fa-lock"></i>
                        </span>
                    </div>
                </div>
            </div>
            <div class="field" :class="{'is-horizontal': horizontal}">
                <input class="button" type="submit" value="Log In" :style="{ margin: horizontal? 'auto':'inherit'}">
            </div>
            <b-modal :active.sync="showTwoFactor" has-modal-card>
                <div class="modal-card">
                    <header class="modal-card-head">
                        <p class="modal-card-title">Two Factor Token</p>
                    </header>
                    <section class="modal-card-body">
                        <p>Please enter your Two Factor Authentication Token.</p>
                        <p>
                            If you are using an <a
                            href="https://www.pcworld.com/article/3225913/what-is-two-factor-authentication-and-which-2fa-apps-are-best.html"
                            class="is-link">app</a>, then please open it and enter the token there.
                        </p>
                        <p>If you signed up for SMS tokens, you should receive a text message with your token.</p>
                        <br>
                        <div class="field">
                            <label class="label" for="token">Token</label>
                            <div class="control has-icons-left">
                                <input id="token" class="input" type="text" name="token" v-model="token" required>
                                <span class="icon is-small is-left">
                                    <i class="fas fa-mobile"></i>
                                </span>
                            </div>
                        </div>
                        <input class="button" type="submit" value="Log In">
                    </section>
                </div>
            </b-modal>
        </form>
    </div>
</template>
<script>
    import ErrorNotifications from "heat-shared/src/components/ErrorNotifications";
    import BLoading from "buefy/src/components/loading/Loading";
    import BModal from "buefy/src/components/modal/Modal";
    import urls from "../urls";
    import axios from "axios";

    export default {
        name: "Login",
        components: {BLoading, BModal, ErrorNotifications},
        props: {
            "horizontal": {
                type: Boolean,
                default: false,
            },
        },
        data: function () {
            return {
                'username': '',
                'password': '',
                'errors': [],
                'isLoading': false,
                'showTwoFactor': false,
                'token': '',
            }
        },
        methods: {
            async logIn() {
                this.isLoading = true;
                this.showTwoFactor = false;
                this.errors = [];
                let redirect_to = this.$route.query.next || null;
                try {
                    axios.defaults.headers.common['Authorization'] = '';
                    let response = await axios.post(urls['login'],
                        {
                            'username': this.username,
                            'password': this.password,
                            'token': this.token,
                        },
                        {'Content-type': 'application/json'});
                    this.isLoading = false;
                    //Using 202 To mean "A Token is Required"
                    if (202 === response.status) {
                        this.showTwoFactor = true;
                        return;
                    }
                    if (typeof(response.data['key']) !== "string") {
                        // noinspection ExceptionCaughtLocallyJS
                        throw Error('Server sent invalid data');
                    }
                    localStorage.setItem('Token', response.data['key']);
                    await this.$store.dispatch('user/getUser');
                    this.$gtag.event('login', {event_category: 'Account'});
                    if(redirect_to !== null){
                        this.$router.push(redirect_to);
                    }
                } catch (error) {
                    this.isLoading = false;
                    this.errors = [error.message];
                    if(error.response && typeof(error.response.data) === "object") {
                        this.errors = Object.values(error.response.data);
                    }
                }
                if (this.errors) {
                    this.token = '';
                }
            }
        }
    }
</script>
<style>
    /*Everything uses the Bulma CSS framework with Buefy*/
</style>
